module.exports = __webpack_public_path__ + "images/pr_home_page.gif";